import { parse } from '@handlebars/parser';
import { ProgramSerializer } from 'modules/handlebars/domain/program';
import { replaceElement } from './replaceElement';
import { htmlStringToNode } from './htmlStringToNode';
import { processTokensInStatements } from './processTokensInStatements';

export const processTokensInNode = (unprocessedNode: Node) => {
  const { textContent } = unprocessedNode;
  const { body: unprocessedStatements, ...handlebarsConfig } = parse(textContent ?? '');
  const processedStatements = processTokensInStatements(unprocessedStatements);
  const someStatementsWereChanged = processedStatements.some(
    (processedStatement, i) => processedStatement !== unprocessedStatements[i],
  );

  if (someStatementsWereChanged) {
    const processedNode = htmlStringToNode(
      ProgramSerializer.serialize({
        body: processedStatements,
        ...handlebarsConfig,
      }),
    );
    replaceElement(unprocessedNode, processedNode);
  }
};
